<div [class.noShowCarroCompra]="!show" [class.showCarroCompra]="show">
  <app-header [displayCartOnMobile]="enableDiscountBox"> </app-header>
  <div class="container">
    <div class="row">
      <div class="col-md pr-24">
        <div class="w-left">
          <div class="col-12 mt-15">
            <span class="title title-resumen-compra">¡Así de fácil! Revisa los detalles de la contratación y confirma</span>
          </div>
          <div class="card-principal resumen-compra-container mt-30">
            <div class="row mt-0">
              <span class="subTitle">Resumen de tu orden</span>
            </div>
            <div class="row-resumen">

              <app-messages *ngIf="!loading" class="informativo"
                message="Resumen de orden de factura para <b>{{ mensaje }}</b> ">
              </app-messages>
              <div class="row-resumen-orden datos-persona-resumen">
                <div class="col-12 col-md-4 p-0">
                  <label class="datos" for="rut">RUT:</label>
                </div>
                <div class="col-12 col-md-8 p-0">
                  <label class="datos-cliente" for="nombre">{{data.run}}</label>
                </div>
              </div>
              <div class="row-resumen-orden datos-persona-resumen">
                <div class=" col-12 col-md-4 p-0">
                  <label class="datos" for="email">Nombre:</label>
                </div>
                <div class=" col-12 col-md-8 p-0">
                  <label class="datos-cliente" for="telefono">{{data.name}}</label>
                </div>
              </div>
              <div class="row-resumen-orden datos-persona-resumen">
                <div class="col-12 col-md-4 p-0">
                  <label class="datos" for="rutTitular">Correo electrónico:</label>
                </div>
                <div class=" col-12 col-md-8 p-0">
                  <label class="datos-cliente" for="nombresTitular">{{data.email}}</label>
                </div>
              </div>
              <div class="row-resumen-orden datos-persona-resumen">
                <div class="col-12 col-md-4 p-0">
                  <label class="datos" for="rutTitular">Teléfono contacto:</label>
                </div>
                <div class="col-12 col-md-8 p-0">
                  <label class="datos-cliente" for="nombresTitular">{{data.phone}}</label>
                </div>
              </div>

              <div class="row-botones-continuar">
                <div class="col-12 col-md-4 w-right pl-0">
                  <button *ngIf="!loadingButton" [disabled]="pagoBlocked" class="btn-primary-tbk" type="button" (click)="goPay()">
                    <i class="icon-mail" ></i>
                    <ng-container *ngIf="isWix; else otroProducto">Ir a Pagar WIX</ng-container>
                    <ng-template #otroProducto>Ir a Pagar</ng-template>
                  </button>
                  <button *ngIf="loadingButton" class="btn-primary-tbk" type="button">
                    <div class="spinner-border text-light" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col md pl-0">
        <div class="w-right">
          <ng-container>
            <!-- Se indica que La caja de descuento debe mostrarse en este nivel del Flujo (Resumen Compra)-->
            <app-carro-compra [products]="products$ | async" discountBox="enableDiscountBox"></app-carro-compra>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': showModal ? 'block' : 'none'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content text-center">
      <div class="modal-header text-center">
        <h5 class="modal-title text-center">¿Tienes un código de descuento?</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalCuponHide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        Recuerda ingresarlo antes de ir a pagar.
      </div>
      <div class="modal-footer text-center">
        <button  type="button" class="btn btn-primary-tbk" (click)="modalCuponHide()">Entendido</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': modalEjecutivo ? 'block' : 'none'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content text-center">
      <div class="modal-header text-center">
        <h5 class="modal-title text-center">Link de pago enviado a cliente</h5>
      </div>
      <div class="modal-body text-center">
        Hemos enviado al correo del cliente el link para pagar, una vez realice el pago te reenviaremos el comprobante
      </div>
      <div class="modal-footer text-center">
        <button  type="button" class="btn btn-primary-tbk" (click)="modalMsjEjecutivoHide()">Entendido</button>
      </div>
    </div>
  </div>
</div>